import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Are you sure?", 
  message = "This action cannot be undone.", 
  confirmText = "Delete", 
  cancelText = "Cancel",
  variant = "danger" 
}) => {
  if (!isOpen) return null;

  const variantColors = {
    danger: "bg-red-500 text-white hover:bg-red-600",
    primary: "bg-[#A3E635] text-black hover:scale-105"
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm" 
        onClick={onClose} 
      />
      <div className="relative bg-[#1C1C1E] border border-[#2C2C2E] rounded-[40px] w-full max-w-md p-8 animate-in zoom-in duration-200">
        <button 
          onClick={onClose} 
          className="absolute top-6 right-6 text-slate-500 hover:text-white transition-colors"
        >
          <X size={24} />
        </button>

        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center text-red-500 mb-6">
            <AlertTriangle size={32} />
          </div>

          <h3 className="text-2xl font-black italic uppercase tracking-tighter mb-2">
            {title}
          </h3>
          <p className="text-slate-500 font-bold uppercase tracking-widest text-xs mb-8">
            {message}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <button
              onClick={onConfirm}
              className={`flex-1 py-4 rounded-full font-black uppercase tracking-widest text-sm transition-all ${variantColors[variant]}`}
            >
              {confirmText}
            </button>
            <button
              onClick={onClose}
              className="flex-1 py-4 rounded-full font-black uppercase tracking-widest text-sm bg-[#2C2C2E] text-slate-300 hover:bg-[#3C3C3E] transition-all"
            >
              {cancelText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
